import { useQuery } from '@tanstack/react-query';

import { api, unwrap } from './api/client.js';

/**
 * Days of the free Business trial, from the public plans of the API (one source with billing and
 * the landing; signed out too). Undefined while loading: texts with the number wait for it.
 */
export function useTrialDays(): number | undefined {
  const plans = useQuery({
    queryKey: ['plans'],
    queryFn: () => unwrap(api.GET('/billing/plans')),
    staleTime: 60 * 60_000,
  });
  return plans.data?.trialDays;
}
